import React from 'react';
const style = { fontSize: '18px', fontWeight: 'bold' };

const Total = ({ data, params }) => {
    let td = getValues(params.slice(4), data);

    return (
        <tr>
            <td colSpan={4}>Total</td>
            {td}
        </tr>
    );
};

function getValues(params, row) {
    return params.map(param => {
        const value = row[param] || '';

        return (<td style={style} key={param}>{value}</td>);
    });
}

export default Total;



// WEBPACK FOOTER //
// ./src/scenes/PropellerAdsReport/components/Table/components/TotalRow/index.js